import { types, flow, applySnapshot, getSnapshot } from 'mobx-state-tree';
import { makeRequest, errorResponse } from 'js/services/Network';

import TransactionsPaginator from './TransactionsPaginator';

export default types
  .model('CreditCard', {
    isLoading: false,
    error: types.maybeNull(types.string),

    id: types.number,
    created_at: types.maybe(types.string),
    credit_card: types.maybe(types.string),
    credit_card_type: types.maybe(types.string),
    is_preauthed: types.maybe(types.boolean),
    preauth_transaction_id: types.maybeNull(types.number),
    user_name: types.maybeNull(types.string),
    user_email: types.maybeNull(types.string),

    transactions: types.optional(TransactionsPaginator, {}),
  })
  .actions(self => ({
    afterCreate() {
      self.transactions.credit_card_id = self.id;
      self.transactions.load();
    },
    load: flow(function* load() {
      let response;

      if (!self.isLoading) {
        self.isLoading = true;
        self.error = null;

        try {
          response = yield makeRequest('admin-credit-card-data', null, { id: self.id });
          applySnapshot(self, { ...getSnapshot(self), ...response.data });
        } catch (error) {
          self.error = errorResponse(error);
        }

        self.isLoading = false;
      }

      return response;
    }),
  }));
